import type { CSSProperties } from 'react';

/**
 * Shared mobile drawer geometry constants for Goblinbox.
 *
 * The mobile layout has:
 *   - A fixed header: 56px + env(safe-area-inset-top)
 *   - A fixed bottom nav: 56px + env(safe-area-inset-bottom)
 *
 * All bottom-sheet drawers should:
 *   - Sit above the bottom nav bar
 *   - Expand upward to fill the full space between the header and the nav
 *   - Have their overlay mask only the usable content area (not the header or nav)
 */

/** Max height a drawer may grow — fills from nav top all the way up to header bottom. */
export const MOBILE_DRAWER_MAX_HEIGHT =
  'calc(100dvh - 56px - env(safe-area-inset-top) - 56px - env(safe-area-inset-bottom))';

/** Inline styles applied to every mobile DrawerContent. */
export const mobileDrawerContentStyle: CSSProperties = {
  bottom: 'calc(56px + env(safe-area-inset-bottom))',
  maxHeight: MOBILE_DRAWER_MAX_HEIGHT,
};

/**
 * className applied to the DrawerOverlay so it only masks the usable area
 * (between header bottom and nav top), leaving both bars fully visible.
 */
export const MOBILE_DRAWER_OVERLAY_CLASS =
  'top-[calc(56px+env(safe-area-inset-top))] bottom-[calc(56px+env(safe-area-inset-bottom))]';
